<template>
  <div class="personal-center-page">
    <div class="top-content">
      <SearchNav />
    </div>
    <div class="content flex">
      <div class="left-side flex column">
        <div
          :class="[
            'pointer menu-item',
            selected === item.key || $route.meta.sidebar === item.key ? 'menu-item-active' : '',
            item.justShow ? 'menu-level' : ''
          ]"
          :key="item.key"
          v-for="item in menu"
          @click="changeItem(item.key, item.path)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="right-side">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/components/SearchNav';
import { menuList } from '@/const/personalMenu';
export default {
  name: 'personalCenter',
  mounted() {
    this.menu = menuList;
  },
  components: {
    SearchNav
  },
  data() {
    return {
      selected: '',
      menu: []
    };
  },
  methods: {
    changeItem(key, path) {
      if (!path) {
        return;
      }
      this.selected = key;
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.banner__warp {
  width: 1232px;
  margin: 0 auto;
  background-color: #ffffff;
}
.personal-center-page {
  padding-bottom: 30px;
  background-color: #fafafa;
  .top-content {
    background-color: #ffffff;
  }
  .content {
    min-height: 539px;
    .left-side {
      width: 200px;
      min-height: 539px;
      background-color: #ffffff;
      .menu-item {
        height: 46px;
        line-height: 46px;
        font-size: 14px;
        font-weight: 400;
        color: #262626;
        padding-left: 16px;
      }
      .menu-item-active {
        color: #1e8dff;
        background: #e9f8ff;
      }
      .menu-level {
        height: 50px;
        font-size: 18px;
        font-weight: 400;
        color: #8c8c8c;
        line-height: 50px;
      }
    }
    .right-side {
      padding: 16px;
      padding-bottom: 0;
      width: 100%;
    }
  }
}
</style>
